import { queryString } from '@olivierpascal/helpers';
import { Helmet } from 'react-helmet-async';

import { getAppSettings } from '~/lib/appSettings';

export type IGoogleTagManagerProps = Record<string, never>;

export const GoogleTagManager: React.FC<IGoogleTagManagerProps> = () => {
  const appSettings = getAppSettings();
  const gtmSettings = appSettings.analytics.googleTagManager;
  if (!gtmSettings?.enabled) {
    return null;
  }

  const gtmEnvironmentQueryString = queryString.build({
    gtm_auth: gtmSettings.environment.auth,
    gtm_preview: gtmSettings.environment.preview,
    gtm_cookies_win: 'x',
  });

  return (
    <>
      <Helmet>
        <script type="text/javascript" key="google-tag-manager">
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl+'&${gtmEnvironmentQueryString}';
            f.parentNode.insertBefore(j,f);})
            (window,document,'script','dataLayer','${gtmSettings.environment.id}');
          `}
        </script>
      </Helmet>

      <noscript key="google-tag-manager-noscript">
        {`<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmSettings.environment.id}&${gtmEnvironmentQueryString}"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>
        `}
      </noscript>
    </>
  );
};
